import React, { useState, useReducer, useEffect, useContext } from "react";
import {
  Alert,
  Card,
  Col,
  Row,
  Table,
  Badge,
  Image,
  Dropdown,
} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import queryString from "query-string";
import moduleConfig from "./moduleConfig";
import axios from "../../../config/axios";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../config/toastNotification";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";
import useConfirm from "../../../HOC/custom/useConfirm";
import ListingFooter from "./partials/listing/ListingFooter";
import SearchArea from "./partials/listing/SearchArea";
import Item from "./partials/listing/Item";

import { OverlayLoading } from "../../UI/loading/OverlayLoading";
import {
  loadItemsGeneral,
  resetFiltersGeneral,
  setFilterGeneral,
} from "../../../helpers/ModuleHelperFunctions";
import {
  listingReducer,
  listingInitialState,
} from "../../../reducers/module/listingReducer";

const OrdersListing = () => {
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  const [listingState, listingDispatch] = useReducer(
    listingReducer,
    listingInitialState
  );
  const { confirm } = useConfirm();
  const { search } = useLocation();
  let history = useNavigate();
  const [appliedFilters, setAppliedFilters] = useState(
    queryString.parse(search)
  );
  if (appliedFilters.limit) {
    moduleConfig.perPageItems = appliedFilters.limit;
  }

  const setFilter = (name, value) => {
    setFilterGeneral(name, value, appliedFilters, setAppliedFilters, history);
  };

  const resetFilters = () => {
    resetFiltersGeneral(
      appliedFilters,
      setAppliedFilters,
      history,
      moduleConfig
    );
  };

  useEffect(() => {
    loadItemsGeneral(listingDispatch, moduleConfig.url, search);
  }, [search]);

  useEffect(() => {
    setBreadcrumb([moduleConfig.breadcrumbs.listing]);
  }, []);

  const confirmAndDisabled = async (id) => {
    const isConfirmed = await confirm(
      `Do you really want to mark this order as processing?`
    );

    if (isConfirmed) {
      await changeStatus(id);
    }
  };

  const confirmAndEnabled = async (id) => {
    const isConfirmed = await confirm(
      `Do you really want to mark this order as completed ?`
    );

    if (isConfirmed) {
      await changeStatus(id, true);
    }
  };

  const changeStatus = async (id, undo = false) => {
    listingDispatch({
      type: "BLOCK_REQUEST",
    });

    try {
      const res = await axios.post(`${moduleConfig.url}/change-status`, {
        id,
        status: undo === true ? "1" : "0",
      });
      loadItemsGeneral(listingDispatch, moduleConfig.url, search);
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `${moduleConfig.singleItemTitle} status changed successfully.`,
        type: "success",
      });
    } catch (error) {
      listingDispatch({
        type: "BLOCK_FAILURE",
        payload: error,
      });

      setTimeout(() => {
        listingDispatch({
          type: "REMOVE_ERROR",
        });
      }, 5000);
    }
  };
  const download = (type) => {
    axios
      .post(`/orders/download`, {
        type,
        ids: [],
      })
      .then(function (response) {
        console.log(response);

        let blob = new Blob([response.data], { type: "text/csv" }),
          downloadUrl = window.URL.createObjectURL(blob),
          filename = type + "-payments.csv";
        let a = document.createElement("a");
        if (typeof a.download === "undefined") {
          window.location.href = downloadUrl;
        } else {
          a.href = downloadUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
        }
      });
  };
  return (
    <DashboardLayout>
      {listingState.isLoading && <OverlayLoading />}

      {listingState.status !== "fetching" && (
        <>
          {listingState.error && listingState.status === "fetchFailed" ? (
            <BlockErrorMessage error={listingState.error} />
          ) : (
            <>
              <ModuleHeader
                moduleTitle={moduleConfig.title}
                moduleUrl={moduleConfig.url}
              >
                {/* {listingState.data &&
                  listingState.data.pagination &&
                  listingState.data.pagination.totalItems > 0 && (
                    <Dropdown className="">
                      <Dropdown.Toggle
                        className="border btn btn-custom-2"
                        id="dropdown-basic"
                      >
                        <i className="fa fa-download"> </i> Download &nbsp;
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => download("all")}>
                          All Orders
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => download("paid")}>
                          Completed Orders
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => download("pending")}>
                          Processing Orders
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => download("pending")}>
                          Cancelled Orders
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  )} */}
              </ModuleHeader>

              <div className="listingPage">
                {listingState.data &&
                listingState.data.pagination &&
                listingState.data.pagination.totalItems > 0 ? (
                  <>
                    {/* Search Area */}
                    <SearchArea
                      moduleConfig={moduleConfig}
                      setFilter={setFilter}
                      appliedFilters={appliedFilters}
                      resetFilters={resetFilters}
                    />

                    {/* Listing */}
                    <section className="content listing ">
                      {listingState.error && (
                        <FormErrorMessage error={listingState.error} />
                      )}

                      {!listingState.data.items ||
                      listingState.data.items.length <= 0 ? (
                        <Alert className="alert-custom-1">
                          No records found with selected filters.{" "}
                          <Alert.Link
                            href="#"
                            className="text-custom-3"
                            onClick={() => resetFilters()}
                          >
                            <i className="fas fa-times text-custom-3" /> Reset
                            Filters
                          </Alert.Link>
                          .
                        </Alert>
                      ) : (
                        <>
                          {listingState.data.items &&
                            listingState.data.items.length > 0 && (
                              <Card className="borderCream mb-3">
                                <div className="table-responsive">
                                  <Table
                                    hover
                                    responsive
                                    className="align-middle mb-0"
                                  >
                                    <thead className="bg-light text-center small text-muted">
                                      <tr>
                                        <th className="py-2">#</th>
                                        <th className="py-2">Order ID</th>
                                        <th className="py-2">Customer</th>
                                        <th className="py-2">Products</th>
                                        <th className="py-2">Total</th>
                                        <th className="py-2">Payment</th>
                                        <th className="py-2">Ordered Date</th>
                                        <th className="py-2">Order Status</th>
                                        <th className="py-2">Action</th>
                                      </tr>
                                    </thead>

                                    <tbody className="text-center">
                                      {listingState.data.items.map(
                                        (item, index) => (
                                          <Item
                                            key={index}
                                            moduleConfig={moduleConfig}
                                            item={item}
                                            confirmAndDisabled={
                                              confirmAndDisabled
                                            }
                                            confirmAndEnabled={
                                              confirmAndEnabled
                                            }
                                            customButtonsForItems={[]}
                                          />
                                        )
                                      )}
                                    </tbody>
                                  </Table>
                                </div>
                              </Card>
                            )}
                        </>
                      )}
                    </section>

                    <ListingFooter
                      listingState={listingState}
                      moduleConfig={moduleConfig}
                      // performBulkAction={performBulkAction}
                      setFilter={setFilter}
                    />
                  </>
                ) : (
                  <Alert className="alert-custom-1">No records found.</Alert>
                )}
              </div>
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default OrdersListing;
